import React from 'react';
import { Box } from '@amzn/awsui-components-react';
import AgentChat from './AgentChat';
import { TEST_CASE_AGENT_RUNTIME_ARN, isArnConfigured } from '../../constants';

const TestCaseAgentChat: React.FC = () => {
  if (!isArnConfigured(TEST_CASE_AGENT_RUNTIME_ARN)) {
    return <Box textAlign="center" padding="xxl">Test Case Agent is not yet available in this environment.</Box>;
  }

  return (
    <AgentChat
      agentRuntimeArn={TEST_CASE_AGENT_RUNTIME_ARN}
      title="Test Case Agent"
      description="Generate, analyze, and manage MCP test cases"
      emptySubtitle="Ask me to generate test cases, show distributions, or update parameters."
    />
  );
};

export default TestCaseAgentChat;
